/* RESPONSIBLE TEAM: team-inbox-experience */
import { fragmentArray } from 'ember-data-model-fragments/attributes';
import Fragment from 'ember-data-model-fragments/fragment';

export default Fragment.extend({
  links: fragmentArray('appstore/app-package/quick-links/link'),
});
